import { CardRadioGroup } from "@/components/basic/CardRadioGroup/CardRadioGroup";
import { Icon } from "@rmwc/icon";
import { IconOptions } from "@rmwc/types";

type Props = {
  selectValue?: string;
  setFieldValue: Function;
  name?: string;
  defaultClearValue?: string | number;
  allowClearSelected?: boolean;
  radios: {
    name?: string;
    value?: string;
    icon: string;
    title: string;
    description: string;
    price: string;
  }[];
};

export const CheckoutCardRadios = ({
  name = "",
  selectValue,
  setFieldValue,
  defaultClearValue,
  allowClearSelected,
  radios,
}: Props) => {
  return (
    <CardRadioGroup
      value={selectValue}
      radios={radios}
      name={name}
      renderContent={(renderOption: {
        icon: string | IconOptions;
        title: string;
        price: string;
        description: string;
      }) => {
        return (
          <div className="flex px-4 py-6">
            <div className="mx-16 flex justify-center align-center text-3xl">
              <Icon icon={renderOption.icon} className="text-3xl" />
            </div>
            <div className="text-left">
              <h3 className="font-bold text-lg">{renderOption.title}</h3>
              <h3 className="text-lg">{renderOption.price}</h3>
              <p
                className="text-xs font-light"
                dangerouslySetInnerHTML={{ __html: renderOption.description }}
              ></p>
            </div>
          </div>
        );
      }}
      onChange={(e) => {
        const value = (e.target as HTMLInputElement).value;
        setFieldValue(name, value);
      }}
      onClickSelected={() => {
        if (allowClearSelected) {
          setFieldValue(name, defaultClearValue || "");
        }
      }}
      wrapperClassName={`flex-col justify-center ${
        radios.length > 1 ? "gap-4" : ""
      } `}
      optionClassName={`!bg-card-bg-grey w-full`}
    ></CardRadioGroup>
  );
};
